import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WatchlistPageComponent } from "./watchlist-page/watchlist-page.component";
import { Routes, RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IconsModule } from "@va/core-library/icons";
import { SharedModule } from "../shared/shared.module";
import { WatchlistModule } from "../watchlist/watchlist.module";
import { WatchlistGridComponent } from "./watchlist-grid/watchlist-grid.component";
import { ShareWatchlistModalComponent } from "./share-watchlist-modal/share-watchlist-modal.component";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzPopoverModule } from "ng-zorro-antd/popover";

const watchlistRoutes: Routes = [
  {
    path: "",
    component: WatchlistPageComponent,
    data: {
      title: "Watchlist Page",
    },
  },
  {
    path: ":watchlistId",
    component: WatchlistPageComponent,
    data: {
      title: "Watchlist Page",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(watchlistRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class WatchlistRoutingModule {}

@NgModule({
  declarations: [
    WatchlistPageComponent,
    WatchlistGridComponent,
    ShareWatchlistModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    WatchlistRoutingModule,
    IconsModule,
    SharedModule,
    WatchlistModule,
    ReactiveFormsModule,
    NzTableModule,
    NzModalModule,
    NzSelectModule,
    NzSpinModule,
    NzSwitchModule,
    NzAutocompleteModule,
    NzInputModule,
    NzButtonModule,
    NzGridModule,
    NzPopoverModule,
    NzToolTipModule,
  ],
})
export class WatchlistPageModule {}
